import { StyleRules, WithStyles, withStyles as withStylesCb } from "@material-ui/core/styles";

import { MIN_HEADER_HEIGHT } from "../../../constants";

export const styles: StyleRules = {
  containerRelative: {
    position: "relative"
  },
  containerAbsolute: {
    position: "absolute",
    top: `-${MIN_HEADER_HEIGHT}px`
  }
};

export type Styles = WithStyles<typeof styles>;
export const withStyles = withStylesCb(styles);
